import { Navigate, useLocation } from 'react-router-dom';
import { useGetMe } from '@hooks/useGetMe.ts';
import { Loading } from '@features/ui/components/loading/loading.tsx';
import { ReactNode } from 'react';
import { AuthUser, TRole } from '@src/types';

interface RestrictedRouteProps {
  deniedRoles: TRole[];
  redirectTo?: string;
  authRedirectTo?: string;
  children:
    | ReactNode
    | ((props: { me: AuthUser | null; loading: boolean }) => ReactNode);
}

const RestrictedRoute = ({
  deniedRoles,
  redirectTo = '/',
  authRedirectTo = '/admin/signin',
  children,
}: RestrictedRouteProps) => {
  const location = useLocation();
  const { me, loading } = useGetMe();

  if (loading) {
    return <Loading />;
  }

  if (!me?.id || !me.role) {
    return (
      <Navigate replace={true} state={{ from: location }} to={authRedirectTo} />
    );
  }

  return !deniedRoles.includes(me.role) ? (
    <Navigate replace to={redirectTo} />
  ) : typeof children === 'function' ? (
    children({ me, loading })
  ) : (
    children
  );
};

export default RestrictedRoute;
